import { putRequest } from '.'

export const updateMember = async (
  teamId: number,
  memberId: number,
  data: Partial<wowaudit.TeamMembership>,
) => {
  return await putRequest(`/api/teams/${teamId}/members/${memberId}`, data)
}
